module.exports = __webpack_public_path__ + "media/MidwestStyleHouse@2x.d4201435.svg";